// headerPaddingTop.ts
import {Platform, Dimensions} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {getStatusBarHeight, isIphoneX} from 'react-native-iphone-screen-helper';

export function getDynamicPaddingTop({translucent = false}: {translucent?: boolean}) {
  const win = Dimensions.get('screen');

  if (Platform.OS === 'ios') {
    if (isIphoneX()) {
      return getStatusBarHeight();
    } else {
      return RFValue(12);
    }
  }

  if (Platform.OS === 'android') {
    if (win.width <= 360) {
      if (translucent) {
        return RFValue(0) + getStatusBarHeight();
      } else {
        return RFValue(10);
      }
    }
    if (translucent) {
      return RFValue(0) + getStatusBarHeight();
    } else {
      return getStatusBarHeight();
    }
  }

  return RFValue(12);
}
